var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#0065FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5183 6.46809L18.014 10.8406C18.3194 11.1269 18.3298 11.5994 18.0371 11.8981C17.8923 12.0401 17.6952 12.1199 17.4896 12.1199C17.284 12.1199 17.0869 12.0401 16.9421 11.8981L13.742 8.80809V16.7806C13.742 17.1948 13.3967 17.5306 12.9708 17.5306C12.545 17.5306 12.1997 17.1948 12.1997 16.7806V8.80809L9.0227 11.8981C8.71675 12.1529 8.26069 12.1358 7.97586 11.8588C7.69103 11.5817 7.67342 11.1382 7.93542 10.8406L12.431 6.46809C12.7318 6.1773 13.2176 6.1773 13.5183 6.46809Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11523 18.2806H16.8264C17.2523 18.2806 17.5975 18.6164 17.5975 19.0306C17.5975 19.4448 17.2523 19.7806 16.8264 19.7806H9.11523C8.68936 19.7806 8.34411 19.4448 8.34411 19.0306C8.34411 18.6164 8.68936 18.2806 9.11523 18.2806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.7b99d3e45ec7d7026fee28168a62d7e4.svg";
export { ForwardRef as ReactComponent };